<template>
	<core-pagination :total="count" :page-total="pageTotal" :per-page="perPage" :page="page" @changePage="changePage" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('monsterleads');

export default {
	props: {
		pageTotal: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		...mapState(['count', 'page']),
		...mapGetters(['perPage']),
		totalPages() {
			return Math.ceil(this.count / this.perPage);
		},
	},
	methods: {
		...mapActions(['goToPage']),
		changePage(page) {
			if (page <= this.totalPages && 0 < page) {
				this.goToPage({ page });
			}
		},
	},
};
</script>
